import React from 'react'
import { shallow } from 'enzyme'
import Category from '../Category'

describe('Category', () => {
  let wrapper, props

  const docProps = {
    skipped: false,
    confirmed: false,
    status: 'pending_review',
    uploaded: false,
    skippable: false,
    referenceFiles: "[]",
    adminOnly: false,
    deletable: false,
    displayCommentable: false,
    esignable: false,
    live: true,
    rid: 123,
    title: 'title',
    type: 'Document',
    files: [
      {
        is_new: false,
        name: 'foo.jpg'
      }
    ]
  }

  beforeAll( () => {
    props = {
      documents: [{ ...docProps }],
      entityId: '1',
      categories: [],
      loanId: 22,
      guarantors: [],
      resourceType: 'Guarantor',
      superUser: true,
      canComment: false,
      bankAdmin: false,
      customerService: true,
      disabled: false,
      idx: 123,
      category: 'cat',
      affiliateIds: [],
      entity: [],
      resetClientStore: () => {
        return true
      },
      handedOff: true,
      client: {}
    }
    wrapper = shallow(<Category {...props} />)
  })

  describe('#renderDocuments', () => {
    it('should return obj', () => {
      const obj = wrapper.instance().renderDocuments()
      expect(typeof obj).toBe('object')
    })
  })

  describe('#renderDocumentBucketModal', () => {
    it('should return obj', () => {
      const obj = wrapper.instance().renderDocumentBucketModal()
      expect(typeof obj).toBe('object')
    })
  })

  describe('#allDocuments', () => {
    it('should return obj', () => {
      const { allDocuments } = wrapper.instance()
      expect(typeof allDocuments).toBe('object')
      expect(allDocuments.length).toBe(1)
    })
  })

  describe('#totalDocs', () => {
    it('should return number', () => {
      const { totalDocs } = wrapper.instance()
      expect(totalDocs).toBe(1)
    })
  })

  describe('#uploadedDocs', () => {
    it('should return number', () => {
      const obj = wrapper.instance().uploadedDocs()
      expect(obj).toBe(1)
    })
  })

  describe('#orderedDocs', () => {
    it('should return ordered docs', () => {
      props.documents = [{ ...docProps }, { title: 'Albert'}]
      wrapper.setProps({ ...props })
      const obj = wrapper.instance().orderedDocs()

      expect(typeof obj).toBe('object')
      expect(obj[0].title).toBe('Albert')
    })
  })
})